<template>
  <!--
    «Экспорт» вкладки контент-мониторинга — тот же вид и повадки, что у кнопки
    отчётов по страницам (components/ReportButton.vue), но собирает отчёт CM API
    по текущей вкладке (текст / картинки), периоду и выбранным страницам, и сразу
    отдаёт файл на скачивание. Карточка остаётся в списке отчётов (/reports).
    Страницы — проп pages (на «Все страницы» это все страницы аккаунта, галочек там
    никто не ставит) или выбранные на дашборде; фильтры шапки применяются те же, что у вкладки.
  -->
  <button
    :class="`btn-st-red export ${reportPages.length > 0 ? '' : 'unactive'}`"
    @click="reportPages.length === 0 && showNoPages()"
  >
    <div class="drpdown" v-click-outside="() => { isOpen = false; }">
      <input type="checkbox" name id="cm-export" v-model="isOpen" />
      <label for="cm-export" v-if="!loading">{{ $t('DASH_EXPORT') }} <i class="bi-download"></i></label>
      <scroll-loader loader-size="18" :loader-method="() => {}" :loader-enable="loading"></scroll-loader>

      <ul v-if="reportPages.length">
        <li v-for="type in types" :key="type" @click="exportAs(type); isOpen = false;">
          {{ $t('DASH_EXP_AS') }} {{ type.toUpperCase() }}
        </li>
      </ul>
    </div>
  </button>
</template>

<script>
import { mapGetters } from "vuex";
import ClickOutside from "vue-click-outside";
import cmApi from "@/api/controllers/content-monitoring";
import { saveBlob } from "@/models/content-monitoring/save-blob";
import { filterCmPages } from "@/models/content-monitoring/filter-pages";

export default {
  name: "Cm-report-button",
  directives: { ClickOutside },
  props: {
    // null — страницы, отмеченные на дашборде (getSelectedPages)
    pages: { type: Array, default: null },
  },
  data() {
    return { isOpen: false, loading: false, types: ["pptx", "pdf", "xlsx"] };
  },
  computed: {
    ...mapGetters([
      "getSelectedPages",
      "getPeriod",
      "getCmFormat",
      "getCmOwner",
      "getCmCategory",
      "getCmSocials",
      "getCategories",
    ]),

    reportPages() {
      return filterCmPages(this.pages || this.getSelectedPages, {
        owner: this.getCmOwner,
        category: this.getCmCategory,
        categories: this.getCategories,
        socials: this.getCmSocials,
      });
    },
  },
  methods: {
    async exportAs(type) {
      if (this.loading) return;
      this.loading = true;
      try {
        // страницы отчёта — те, что вкладка реально показывает (заведённые в CM)
        const scope = await cmApi.resolveScope(this.reportPages);
        if (!scope.pageIds.length) {
          this.$alert.show({ message: this.$t("CM_PAGES_NOT_MONITORED"), type: "global", color: "black" });
          return;
        }
        const card = await cmApi.createReport({
          type,
          format: this.getCmFormat,
          period: this.getPeriod,
          pageIds: scope.pageIds,
          lang: this.$i18n.locale,
        });
        const { blob, filename } = await cmApi.downloadReport(card.hash);
        saveBlob(blob, filename);
      } catch (e) {
        this.$alert.show({ message: e.message || String(e), type: "global", color: "black" });
      } finally {
        this.loading = false;
      }
    },
    showNoPages() {
      this.$alert.show({ message: this.$t("DASH_EXPORT_NO_PAGES"), type: "global", color: "black" });
    },
  },
  mounted() {
    this.popupItem = this.$el;
  },
};
</script>
